import React from 'react';
import { Container, Typography, Paper, Grid, Box } from '@mui/material';
import { PageHeader } from '../layout/PageHeader';
import { CallToAction } from '../common/CallToAction';
import { SEOHead, SEO_PAGES } from '../seo/SEOHead';

export const AboutPage: React.FC = () => {
  return (
    <>
      <SEOHead {...SEO_PAGES.about} />
      <PageHeader
        title="About GovToolsPro"
        description="Learn about our mission to simplify government contracting"
      />
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Paper elevation={2} sx={{ p: 4, mb: 4 }}>
              <Typography variant="h5" component="h2" gutterBottom>
                Our Mission
              </Typography>
              <Typography paragraph>
                GovToolsPro is dedicated to revolutionizing how businesses interact with government contracting opportunities. 
                We combine cutting-edge AI technology with deep domain expertise to make the complex world of federal procurement 
                more accessible and manageable for businesses of all sizes.
              </Typography>
              <Typography paragraph>
                Our platform simplifies the process of finding, analyzing, and bidding on government contracts by providing 
                intelligent analysis of SAM.gov opportunities, helping you identify the most relevant and promising opportunities 
                for your business.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper elevation={2} sx={{ p: 4, height: '100%' }}>
              <Typography variant="h5" component="h2" gutterBottom>
                Why Choose GovToolsPro?
              </Typography>
              <Box component="ul" sx={{ pl: 2 }}>
                <Typography component="li" paragraph>
                  AI-Powered Analysis: Our advanced algorithms analyze solicitations to extract key information and insights
                </Typography>
                <Typography component="li" paragraph>
                  Time Savings: Reduce hours of manual review to minutes with our automated analysis
                </Typography>
                <Typography component="li" paragraph>
                  Increased Accuracy: Minimize the risk of missing critical requirements or deadlines
                </Typography>
                <Typography component="li" paragraph>
                  Competitive Advantage: Make more informed decisions with our comprehensive analysis tools
                </Typography>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper elevation={2} sx={{ p: 4, height: '100%' }}>
              <Typography variant="h5" component="h2" gutterBottom>
                Our Technology
              </Typography>
              <Typography paragraph>
                We leverage state-of-the-art artificial intelligence and machine learning technologies to process and analyze 
                government solicitations. Our platform uses natural language processing to understand complex government 
                requirements and presents them in a clear, actionable format.
              </Typography>
              <Typography paragraph>
                By combining multiple AI models and expert-designed algorithms, we provide comprehensive analysis that helps 
                you understand opportunities better and make more informed bidding decisions.
              </Typography>
            </Paper>
          </Grid>
      </Grid>

      <CallToAction
        title="Ready to Transform Your Contracting Process?"
        description="Experience the power of AI-driven government contracting analysis and streamline your bidding process today."
        buttonText="Get Started Now"
        buttonLink="/plans"
        variant="contained"
      />
    </Container>
    </>
  );
};
